import * as React from 'react';

function A16z(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 63 25" fill="none" {...props}>
			<g clipPath="url(#prefix__clip0_21079_236571)" fill="#F2F3F5">
				<path d="M15.353 7.68V6.585l.09-.088h3.913v17.927h-3.912l-.091-.089v-1.272c-1.13.71-2.362 1.316-3.698 1.57-7.268 1.38-13.344-5.08-11.239-12.028 1.739-5.74 8.592-8.357 13.968-5.488.33.176.624.416.969.563zM9.275 9.828c-5 .352-7.159 6.45-3.385 9.716 2.742 2.373 7.077 1.601 8.806-1.53 2.12-3.84-.983-8.5-5.42-8.186zM42.527.164L37.31 6.79c5.947-.277 10.467 4.826 9.503 10.543-1.499 8.89-14.571 10.257-18.066 1.923-1.6-3.814-.395-6.77 1.902-9.88 2.294-3.108 4.766-6.1 7.055-9.212h4.822zm-5.532 10.194c-6.945.6-6.141 11.433.891 10.928 7.114-.512 6.377-11.555-.89-10.928zM53.443 20.81h8.976v3.609H48.53v-3.64l8.916-10.473c.024-.107-.136-.147-.211-.147H48.53V6.61h13.798l.091.09v3.49l-8.732 10.237-.244.383zM26.15.164v24.258h-4.004V3.744l-.09-.09h-2.579V.165h6.672z" />
			</g>
			<defs>
				<clipPath id="prefix__clip0_21079_236571">
					<path
						fill="currentColor"
						transform="translate(-.008 .164)"
						d="M0 0h62.426v24.655H0z"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default A16z;
